// NOTE: Define this on the initialization of the app. User can't go to the Reports page from
// another page and vice versa. On report generation Back-end just goes straight to the Reports page
// using JWT in query params

export const isReportsPage = window.location.pathname.startsWith('/reports/');
